module.exports = __webpack_public_path__ + "img/image153.07940691.jpg";